module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0Ij4NCiAgPHBhdGggaWQ9Iui3r+W+hF8yIiBkYXRhLW5hbWU9Iui3r+W+hCAyIiBkPSJNNywxNGE3LDcsMCwxLDEsNy03QTcsNywwLDAsMSw3LDE0Wk05Ljg1NCw0Ljc1NWEuNDUuNDUsMCwwLDAtLjYzNy0uNjM3TDYuOTg2LDYuMzQ4LDQuNzU1LDQuMTE4YS40NS40NSwwLDAsMC0uNjM3LjYzN2wyLjIzLDIuMjMxTDQuMTE4LDkuMjE3YS40NS40NSwwLDAsMCwuNjM3LjYzN0w2Ljk4Niw3LjYyMyw5LjIxNyw5Ljg1NGEuNDUuNDUsMCwwLDAsLjYzNy0uNjM3TDcuNjIzLDYuOTg2WiIgZmlsbD0iI2NjYyIgZmlsbC1ydWxlPSJldmVub2RkIi8+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/取消.svg
// module id = 350
// module chunks = 0